import { objectMap } from '../languageExtensions/object.js';

/**
 * To avoid exceeding Sentry event size limits, we do not send inner objects or
 * arrays in breadcrumbs. This can be tweaked in the future if event sizes are
 * not too large.
 *
 * Return type is intended to match Sentry's `Breadcrumb['data']` type.
 *
 * https://docs.sentry.io/concepts/data-management/size-limits/
 */

const getLimitedBreadcrumbData = data => {
  if (!data) return undefined;

  try {
    /** Data converted into object format */
    const normalizedData = typeof data === 'object' && !Array.isArray(data) ? data : {
      value: data
    };
    const limitedData = objectMap(normalizedData, value => {
      if (value === null || value === undefined) return value;

      if (typeof value === 'object') {
        return Array.isArray(value) ? '[array]' : '[object]';
      }

      return value;
    });
    return limitedData;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

export { getLimitedBreadcrumbData };
